import { render, staticRenderFns } from "./map-style-menu.vue?vue&type=template&id=32c0f9fa&scoped=true"
import script from "./map-style-menu.vue?vue&type=script&lang=js"
export * from "./map-style-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c0f9fa",
  null
  
)

export default component.exports